import { Getters } from 'vuex-smart-module';
import OrganizationChekState from './state';

export default class OrganizationCheckGetters extends Getters<OrganizationChekState> {}
